import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import MapPage from "./pages/MapPage";
import Documentation from "./pages/Documentation";
import Tools from "./pages/Tools";
import Flowchart from "./pages/Flowchart";
import Assistant from "./pages/Assistant";
import Lawyers from "./pages/Lawyers";
import FAQ from "./pages/FAQ";
import Testimonials from "./pages/Testimonials";
import Messages from "./pages/Messages";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";
import Petition from "./pages/Petition";
import { AuthProvider } from "./context/AuthContext";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="carte" element={<MapPage />} />
            <Route path="documentation" element={<Documentation />} />
            <Route path="outils" element={<Tools />} />
            <Route path="parcours" element={<Flowchart />} />
            <Route path="assistant" element={<Assistant />} />
            <Route path="avocats" element={<Lawyers />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="temoignages" element={<Testimonials />} />
            <Route path="messages" element={<Messages />} />
            <Route path="contact" element={<Contact />} />
            <Route path="profil" element={<Profile />} />
            <Route path="admin" element={<Admin />} />
            <Route path="petition-habitat-leger-2027" element={<Petition />} />
          </Route>
          <Route path="/connexion" element={<Login />} />
          <Route path="/inscription" element={<Register />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
